export const formatTitle = (title, limit = 30) => {
    if (title.length > limit) {
        return `${title.substring(0, limit)}.............${title.substring(
            title.length - 10
        )}`
    }
    return title
}
